import type { Permissions } from "@/types/model/Roles";
import { create } from "zustand";
import { devtools } from "zustand/middleware";

interface userPermissionsState {
  permissions: Permissions;
  setPermissions: (data: Permissions) => void;
}

export const usePermissionsStore = create<userPermissionsState>()(
  devtools(
    (set) => ({
      permissions: {},
      setPermissions: (data) => {
        return set(
          () => ({
            permissions: {
              ...data,
            },
          }));
      },
    }),
    {
      name: "PermissionsStore",
    }
  )
);
